import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SalesFinalMessageComponent} from "./sales-final-message.component";
import {SalesFinalMessageGeneralComponent} from "./general/sales-final-message-general.component";
import {SalesFinalMessageTopUpLoanComponent} from "./top-up-loan/sales-final-message-top-up-loan.component";
import {SalesFinalMessageKredicashComponent} from "./kredicash/sales-final-message-kredicash.component";
import {KrdYaLogoComponent} from "../../shared/resources/krdya-logo/krdya-logo.component";
import {
  SalesFinalMessageKredicashV2Component,
  SalesFinalMessageKredicashV3Component
} from "./kredicash/versions/sales-final-message-kredicash-versions.component";
import {LibraryModule} from "library";
import {PrimengModule} from "../../shared/primeng-module/primeng.module";
import {GeneralModule} from "../general/general.module";

@NgModule({
  declarations: [
    SalesFinalMessageComponent,
    SalesFinalMessageGeneralComponent,
    SalesFinalMessageTopUpLoanComponent,
    SalesFinalMessageKredicashComponent,
    KrdYaLogoComponent,
    SalesFinalMessageKredicashV2Component,
    SalesFinalMessageKredicashV3Component
  ],
  imports: [
    CommonModule,
    LibraryModule,
    PrimengModule,
    GeneralModule
  ],
  exports: [
    SalesFinalMessageComponent,
    SalesFinalMessageTopUpLoanComponent,
  ]
})
export class SalesFinalMessageModule { }
